import React from 'react';
import {TheNews} from './sub-view/the-news';
import {SupportBusiness} from './sub-view/support-business';
import {UserLayout} from 'components/layouts/user';

class UserDashboard extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div>
        <h1 className="user-header">Bảng tin</h1>
        <TheNews/>
        <h1 className="user-header">Hỗ trợ cho doanh nghiệp</h1>
        <SupportBusiness/>
      </div>
    );
  }
}

export default UserDashboard;



// WEBPACK FOOTER //
// ./components/users/UserDashboard.jsx